type SVGProps = JSX.IntrinsicElements['svg'];
type ObjectProps = JSX.IntrinsicElements['object'];
type ImageProps = JSX.IntrinsicElements['img'];
export type SvgTypes =
	| ({ path: 'cash_RTag' } & ObjectProps)
	| ({ path: 'casual_RTag' } & ObjectProps)
	| ({
			path: 'normalRTag';
			/** #6B60FA */
			color1?: string;
	  } & SVGProps)
	| ({ path: 'Create_Casual' } & ImageProps)
	| ({ path: 'Create_Cash' } & ImageProps)
	| ({ path: 'Sticker_Country_48_Select' } & ImageProps)
	| ({
			path: 'Navi_Chevron_24_White_Left';
			/** #FDFDFE */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Navi_Chevron_24_White_Right';
			/** #FDFDFE */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Check_24_Black';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Report_32_Default';
			/** #E0E0E3 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Language_32_Default';
			/** #E0E0E3 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Left';
			/** #FDFDFE */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Right';
			/** #FDFDFE */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Kebab_48_White';
			/** #FDFDFE */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Sticker_Status_Open';
			/** #2AE289 */
			color1?: string;
			/** #1A1A20 */
			color2?: string;
			/** 0.1 */
			percent1?: number;
			/** #FDFDFE */
			color3?: string;
	  } & SVGProps)
	| ({ path: 'ICON_64_Logo_None' } & ObjectProps)
	| ({
			path: 'Sticker_Status_Setup';
			/** #FDFDFE */
			color1?: string;
			/** #1A1A20 */
			color2?: string;
			/** 0.1 */
			percent1?: number;
	  } & SVGProps)
	| ({
			path: 'Sticker_Status_NEW';
			/** #A29BFC */
			color1?: string;
			/** #1A1A20 */
			color2?: string;
			/** 0.1 */
			percent1?: number;
			/** #FDFDFE */
			color3?: string;
	  } & SVGProps)
	| ({ path: 'Sticker_Business_Crown_32' } & ObjectProps)
	| ({
			path: 'Sticker_Status_Done';
			/** #6B60FA */
			color1?: string;
			/** #1A1A20 */
			color2?: string;
			/** 0.1 */
			percent1?: number;
			/** #FDFDFE */
			color3?: string;
	  } & SVGProps)
	| ({
			path: 'Sticker_Status_Live';
			/** #FF005C */
			color1?: string;
			/** #1A1A20 */
			color2?: string;
			/** 0.1 */
			percent1?: number;
			/** #FDFDFE */
			color3?: string;
	  } & SVGProps)
	| ({
			path: 'Sticker_Status_Live2';
			/** #FF91B9 */
			color1?: string;
			/** #1A1A20 */
			color2?: string;
			/** 0.1 */
			percent1?: number;
			/** #FDFDFE */
			color3?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Exclude_24_White';
			/** #FDFDFE */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Human';
			/** #E0E0E3 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_FloatingChat_64_Default';
			/** #FDFDFE */
			color1?: string;
	  } & SVGProps)
	| ({ path: 'Sticker_Sticker_24_Business' } & ObjectProps)
	| ({ path: 'Sticker_Sticker_24_Certify' } & ObjectProps)
	| ({
			path: 'Action_Logout_32_Active';
			/** #FDFDFE */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Navi_Close_48_Black';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'apple_store_logo';
			/** #1A1A20 */
			color1?: string;
			/** #FDFDFE */
			color2?: string;
	  } & SVGProps)
	| ({
			path: 'google_play_logo';
			/** #5FC2E3 */
			color1?: string;
			/** #D83D48 */
			color2?: string;
			/** #289467 */
			color3?: string;
			/** #EB942D */
			color4?: string;
			/** #FDFDFE */
			color5?: string;
	  } & SVGProps)
	| ({ path: 'Sticker_Status_Casual' } & ObjectProps)
	| ({ path: 'Sticker_Status_Cash' } & ObjectProps)
	| ({
			path: 'Action_Meatball_40_Black';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'LeftTail';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'RightTail';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'halfArrowNext';
			/** #FDFDFE */
			color1?: string;
	  } & SVGProps)
	| ({ path: 'QRCode' } & ObjectProps)
	| ({ path: 'cashTrophy' } & ObjectProps)
	| ({ path: 'diaTrophy' } & ObjectProps)
	| ({
			path: 'TabBar_BizAccount_40_Default';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'TabBar_Privacy_40_Active';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'TabBar_Noti_Default_40_Active';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'TabBar_Info_40_Active';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'TabBar_TournamentInquiry_40_Active';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Account_24';
			/** #FDFDFE */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'TabBar_ManageTournament_40_Active';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'TabBar_ManageAccount_40_Active';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_CheckBox_Circle_24_Radio';
			/** #FDFDFE */
			color1?: string;
			/** #A29BFC */
			color2?: string;
	  } & SVGProps)
	| ({
			path: 'Action_CheckBox_Circle_24_Default';
			/** #FDFDFE */
			color1?: string;
			/** #A29BFC */
			color2?: string;
	  } & SVGProps)
	| ({
			path: 'Social_Block_24';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Social_Share_24';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Social_Follow_24_Unfollow';
			/** #1A1A20 */
			color1?: string;
			/** #FF5E98 */
			color2?: string;
			/** #FDFDFE */
			color3?: string;
	  } & SVGProps)
	| ({
			path: 'Social_Follow_24_Follow';
			/** #1A1A20 */
			color1?: string;
			/** #A29BFC */
			color2?: string;
			/** #FDFDFE */
			color3?: string;
	  } & SVGProps)
	| ({
			path: 'Social_Modify_24';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({ path: 'Social_Settings_24_Upload' } & ObjectProps)
	| ({
			path: 'Sticker_Report_24';
			/** #FF5E98 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Sticker_64_Logo_Loading';
			/** #6B60FA */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'TabBar_CreateTournament_32_Active';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'outDoor';
			/** #FF5491 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'inDoor';
			/** #A59FFC */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Plus4x2';
			/** #6B60FA */
			color1?: string;
	  } & SVGProps)
	| ({ path: 'Sticker_Error_Rectangle_100' } & ObjectProps)
	| ({
			path: 'Action_Clear_24_Purple';
			/** #DBD9FE */
			color1?: string;
			/** #FDFDFE */
			color2?: string;
	  } & SVGProps)
	| ({
			path: 'Search24in15';
			/** #A29BFC */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Check';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Upload_24_Purple';
			/** #A29BFC */
			color1?: string;
			/** #FDFDFE */
			color2?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Upload_24_Pink';
			/** #FF5E98 */
			color1?: string;
			/** #FDFDFE */
			color2?: string;
	  } & SVGProps)
	| ({ path: 'successCrown' } & ObjectProps)
	| ({
			path: 'Setting';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Sticker_Error_Round_48';
			/** #FF005C */
			color1?: string;
	  } & SVGProps)
	| ({ path: 'Payment_Image_Diamond_48' } & ImageProps)
	| ({ path: 'Payment_Image_Cash_48' } & ImageProps)
	| ({ path: 'Sticker_Image_Text_48' } & ImageProps)
	| ({ path: 'Sticker_Image_Song_48' } & ImageProps)
	| ({ path: 'Sticker_Image_Global_32' } & ImageProps)
	| ({ path: 'Sticker_Image_Date_32' } & ImageProps)
	| ({ path: 'Sticker_Image_Notice_32' } & ImageProps)
	| ({ path: 'Sticker_Image_Poster_32' } & ImageProps)
	| ({ path: 'Sticker_Image_Banner_48' } & ImageProps)
	| ({ path: 'Sticker_Image_Unlock_48' } & ImageProps)
	| ({ path: 'Sticker_Image_Lock_48' } & ImageProps)
	| ({ path: 'Sticker_Image_SongList_24' } & ImageProps)
	| ({ path: 'Hexagon' } & ObjectProps)
	| ({
			path: 'Action_Play_24_Black';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Stop_24_Black';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'IconCrown';
			/** #ACACB6 */
			color1?: string;
	  } & SVGProps)
	| ({ path: 'Tournament_48_Cash' } & ObjectProps)
	| ({ path: 'Tournament_48_Casual' } & ObjectProps)
	| ({
			path: 'Sticker_Delete_48_Active';
			/** #FF005C */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Tooltip_24_Gray';
			/** #C7C7CD */
			color1?: string;
	  } & SVGProps)
	| ({ path: 'Sticker_2nd' } & ObjectProps)
	| ({ path: 'Sticker_1st' } & ObjectProps)
	| ({ path: 'Sticker_3rd' } & ObjectProps)
	| ({ path: 'Sticker_4th' } & ObjectProps)
	| ({
			path: 'Action_Password_24_Default';
			/** #C7C7CD */
			color1?: string;
			/** #FDFDFE */
			color2?: string;
	  } & SVGProps)
	| ({
			path: 'Action_PasswordCheck_24_Default';
			/** #C7C7CD */
			color1?: string;
			/** #FDFDFE */
			color2?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Code_24_Default';
			/** #C7C7CD */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Email_24_Default';
			/** #C7C7CD */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Action_CheckBox_Circle_24_Active';
			/** #A29BFC */
			color1?: string;
			/** #FDFDFE */
			color2?: string;
	  } & SVGProps)
	| ({
			path: 'Action_Edit_40_Pencil';
			/** #C7C7CD */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Navi_Chevron_24_Black_Down';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Navi_Chevron_24_Black_Up';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps)
	| ({
			path: 'Social_View_Black_Unhide';
			/** #1A1A20 */
			color1?: string;
	  } & SVGProps);
export const useKeys = [
	'normalRTag',
	'Navi_Chevron_24_White_Left',
	'Navi_Chevron_24_White_Right',
	'Action_Check_24_Black',
	'Action_Report_32_Default',
	'Action_Language_32_Default',
	'Left',
	'Right',
	'Action_Kebab_48_White',
	'Sticker_Status_Open',
	'Sticker_Status_Setup',
	'Sticker_Status_NEW',
	'Sticker_Status_Done',
	'Sticker_Status_Live',
	'Sticker_Status_Live2',
	'Action_Exclude_24_White',
	'Human',
	'Action_FloatingChat_64_Default',
	'Action_Logout_32_Active',
	'Navi_Close_48_Black',
	'apple_store_logo',
	'google_play_logo',
	'Action_Meatball_40_Black',
	'LeftTail',
	'RightTail',
	'halfArrowNext',
	'TabBar_BizAccount_40_Default',
	'TabBar_Privacy_40_Active',
	'TabBar_Noti_Default_40_Active',
	'TabBar_Info_40_Active',
	'TabBar_TournamentInquiry_40_Active',
	'Action_Account_24',
	'TabBar_ManageTournament_40_Active',
	'TabBar_ManageAccount_40_Active',
	'Action_CheckBox_Circle_24_Radio',
	'Action_CheckBox_Circle_24_Default',
	'Social_Block_24',
	'Social_Share_24',
	'Social_Follow_24_Unfollow',
	'Social_Follow_24_Follow',
	'Social_Modify_24',
	'Sticker_Report_24',
	'Sticker_64_Logo_Loading',
	'TabBar_CreateTournament_32_Active',
	'outDoor',
	'inDoor',
	'Plus4x2',
	'Action_Clear_24_Purple',
	'Search24in15',
	'Check',
	'Action_Upload_24_Purple',
	'Action_Upload_24_Pink',
	'Setting',
	'Sticker_Error_Round_48',
	'Action_Play_24_Black',
	'Action_Stop_24_Black',
	'IconCrown',
	'Sticker_Delete_48_Active',
	'Action_Tooltip_24_Gray',
	'Action_Password_24_Default',
	'Action_PasswordCheck_24_Default',
	'Action_Code_24_Default',
	'Action_Email_24_Default',
	'Action_CheckBox_Circle_24_Active',
	'Action_Edit_40_Pencil',
	'Navi_Chevron_24_Black_Down',
	'Navi_Chevron_24_Black_Up',
	'Social_View_Black_Unhide',
] as const;
export const imageKeys = [
	'Create_Casual',
	'Create_Cash',
	'Sticker_Country_48_Select',
	'Payment_Image_Diamond_48',
	'Payment_Image_Cash_48',
	'Sticker_Image_Text_48',
	'Sticker_Image_Song_48',
	'Sticker_Image_Global_32',
	'Sticker_Image_Date_32',
	'Sticker_Image_Notice_32',
	'Sticker_Image_Poster_32',
	'Sticker_Image_Banner_48',
	'Sticker_Image_Unlock_48',
	'Sticker_Image_Lock_48',
	'Sticker_Image_SongList_24',
] as const;
export const objectKeys = [
	'cash_RTag',
	'casual_RTag',
	'ICON_64_Logo_None',
	'Sticker_Business_Crown_32',
	'Sticker_Sticker_24_Business',
	'Sticker_Sticker_24_Certify',
	'Sticker_Status_Casual',
	'Sticker_Status_Cash',
	'QRCode',
	'cashTrophy',
	'diaTrophy',
	'Social_Settings_24_Upload',
	'Sticker_Error_Rectangle_100',
	'successCrown',
	'Hexagon',
	'Tournament_48_Cash',
	'Tournament_48_Casual',
	'Sticker_2nd',
	'Sticker_1st',
	'Sticker_3rd',
	'Sticker_4th',
] as const;
export type SvgPaths = SvgTypes['path']; // Svg들의 path 타입을 추출
export type SvgPropsType<T extends SvgPaths> = Extract<SvgTypes, { path: T }>;
export const scales = ['_2x'];
export const usePropsObject = {
	Action_Account_24: { color1: 'svg-color-1' },
	Action_Check_24_Black: { color1: 'svg-color-1' },
	Action_CheckBox_Circle_24_Active: { color1: 'svg-color-1', color2: 'svg-color-2' },
	Action_CheckBox_Circle_24_Default: { color1: 'svg-color-1', color2: 'svg-color-2' },
	Action_CheckBox_Circle_24_Radio: { color1: 'svg-color-1', color2: 'svg-color-2' },
	Action_Clear_24_Purple: { color1: 'svg-color-1', color2: 'svg-color-2' },
	Action_Code_24_Default: { color1: 'svg-color-1' },
	Action_Edit_40_Pencil: { color1: 'svg-color-1' },
	Action_Email_24_Default: { color1: 'svg-color-1' },
	Action_Exclude_24_White: { color1: 'svg-color-1' },
	Action_FloatingChat_64_Default: { color1: 'svg-color-1' },
	Action_Kebab_48_White: { color1: 'svg-color-1' },
	Action_Language_32_Default: { color1: 'svg-color-1' },
	Action_Logout_32_Active: { color1: 'svg-color-1' },
	Action_Meatball_40_Black: { color1: 'svg-color-1' },
	Action_Password_24_Default: { color1: 'svg-color-1', color2: 'svg-color-2' },
	Action_PasswordCheck_24_Default: { color1: 'svg-color-1', color2: 'svg-color-2' },
	Action_Play_24_Black: { color1: 'svg-color-1' },
	Action_Report_32_Default: { color1: 'svg-color-1' },
	Action_Stop_24_Black: { color1: 'svg-color-1' },
	Action_Tooltip_24_Gray: { color1: 'svg-color-1' },
	Action_Upload_24_Pink: { color1: 'svg-color-1', color2: 'svg-color-2' },
	Action_Upload_24_Purple: { color1: 'svg-color-1', color2: 'svg-color-2' },
	apple_store_logo: { color1: 'svg-color-1', color2: 'svg-color-2' },
	Check: { color1: 'svg-color-1' },
	google_play_logo: {
		color1: 'svg-color-1',
		color2: 'svg-color-2',
		color3: 'svg-color-3',
		color4: 'svg-color-4',
		color5: 'svg-color-5',
	},
	Human: { color1: 'svg-color-1' },
	halfArrowNext: { color1: 'svg-color-1' },
	IconCrown: { color1: 'svg-color-1' },
	inDoor: { color1: 'svg-color-1' },
	Left: { color1: 'svg-color-1' },
	LeftTail: { color1: 'svg-color-1' },
	Navi_Chevron_24_Black_Down: { color1: 'svg-color-1' },
	Navi_Chevron_24_Black_Up: { color1: 'svg-color-1' },
	Navi_Chevron_24_White_Left: { color1: 'svg-color-1' },
	Navi_Chevron_24_White_Right: { color1: 'svg-color-1' },
	Navi_Close_48_Black: { color1: 'svg-color-1' },
	normalRTag: { color1: 'svg-color-1' },
	outDoor: { color1: 'svg-color-1' },
	Plus4x2: { color1: 'svg-color-1' },
	Right: { color1: 'svg-color-1' },
	RightTail: { color1: 'svg-color-1' },
	Search24in15: { color1: 'svg-color-1' },
	Setting: { color1: 'svg-color-1' },
	Social_Block_24: { color1: 'svg-color-1' },
	Social_Follow_24_Follow: { color1: 'svg-color-1', color2: 'svg-color-2', color3: 'svg-color-3' },
	Social_Follow_24_Unfollow: {
		color1: 'svg-color-1',
		color2: 'svg-color-2',
		color3: 'svg-color-3',
	},
	Social_Modify_24: { color1: 'svg-color-1' },
	Social_Share_24: { color1: 'svg-color-1' },
	Social_View_Black_Unhide: { color1: 'svg-color-1' },
	Sticker_64_Logo_Loading: { color1: 'svg-color-1' },
	Sticker_Delete_48_Active: { color1: 'svg-color-1' },
	Sticker_Error_Round_48: { color1: 'svg-color-1' },
	Sticker_Report_24: { color1: 'svg-color-1' },
	Sticker_Status_Done: {
		color1: 'svg-color-1',
		color2: 'svg-color-2',
		color3: 'svg-color-3',
		percent1: 'svg-percent-1',
	},
	Sticker_Status_Live: {
		color1: 'svg-color-1',
		color2: 'svg-color-2',
		color3: 'svg-color-3',
		percent1: 'svg-percent-1',
	},
	Sticker_Status_Live2: {
		color1: 'svg-color-1',
		color2: 'svg-color-2',
		color3: 'svg-color-3',
		percent1: 'svg-percent-1',
	},
	Sticker_Status_NEW: {
		color1: 'svg-color-1',
		color2: 'svg-color-2',
		color3: 'svg-color-3',
		percent1: 'svg-percent-1',
	},
	Sticker_Status_Open: {
		color1: 'svg-color-1',
		color2: 'svg-color-2',
		color3: 'svg-color-3',
		percent1: 'svg-percent-1',
	},
	Sticker_Status_Setup: { color1: 'svg-color-1', color2: 'svg-color-2', percent1: 'svg-percent-1' },
	TabBar_BizAccount_40_Default: { color1: 'svg-color-1' },
	TabBar_CreateTournament_32_Active: { color1: 'svg-color-1' },
	TabBar_Info_40_Active: { color1: 'svg-color-1' },
	TabBar_ManageAccount_40_Active: { color1: 'svg-color-1' },
	TabBar_ManageTournament_40_Active: { color1: 'svg-color-1' },
	TabBar_Noti_Default_40_Active: { color1: 'svg-color-1' },
	TabBar_Privacy_40_Active: { color1: 'svg-color-1' },
	TabBar_TournamentInquiry_40_Active: { color1: 'svg-color-1' },
};

import type { CSSProperties, JSX } from 'react';

type IconProps = {
	alt?: string;
	fill?: boolean;
	className?: string;
	style?: CSSProperties;
	options?: FilterOptions;
};

type NullableString = string | boolean | undefined;

/**
 * safety class Composer util
 * @example clc(styles.a,styles.b,'c')
 * @param classNames
 * @returns {string}
 */
const clc = (...classNames: NullableString[]) => {
	return classNames
		.filter((text): text is string => typeof text === 'string')
		.map((txt) => txt.trim())
		.join(' ');
};

const fillStyles = (isFill?: boolean) => {
	if (isFill)
		return {
			objectFit: 'cover',
		} as const;
	return {};
};

type FilterOptions = {
	blur?: number | string;
	brightness?: number | string;
	contrast?: number | string;
	grayscale?: number | string;
	invert?: number | string;
	saturate?: number | string;
	sepia?: number | string;
	opacity?: number | string;
	'drop-shadow'?: string;
	'hue-rotate'?: string;
};

const filterStyle = (options?: FilterOptions) => {
	if (!options) return {};
	const { opacity, ...filters } = options;

	const filter = Object.entries(filters)
		.map(([key, value]) => `${key}(${value})`)
		.join(' ');

	return {
		filter: filter,
		opacity: opacity,
	};
};

/**
 * svg를 저장하는 위치에 따라 다르게 정의해야함
 *
 * public/~
 */
const objectPath = '/object/';
const Icon = <T extends SvgPaths>({
	alt,
	path,
	className,
	style,
	fill,
	options,
	...props
}: SvgPropsType<T> & IconProps) => {
	// use 랑 object 분기 처리
	// 그냥 리스트에서 이름 있는 쪽으로 분기 처리
	const isUse = (useKeys as unknown as string[]).includes(path);
	const isObject = (objectKeys as unknown as string[]).includes(path);
	const isImage = (imageKeys as unknown as string[]).includes(path);

	const attrAlt = alt == null ? path : alt;

	if (isUse) {
		// asset 저장 방식에 맞춰서 호출
		// 만약 코드에 인라인으로 넣게 되면 바로 # 만 쓰면 된다
		// 외부 경로에서 오는 것은 고려하지 않아도 되는게 CORS 에러 나서 외부 리소스를 SVGUSE로 쓸 수 없다
		const assetPath = '/asset.svg?v=1#';
		const attrPath = path as (typeof useKeys)[number];
		const src = assetPath + attrPath;

		// var props 추출해서 스타일에 넣는 코드,
		// use에만 적용하면 됨 > object에는 해당 코드를 제거했기 때문

		// 대충 propsKey : cssKey 임
		const varNames = Object.entries(usePropsObject[attrPath]);
		const varStyles = {} as Record<string, string>;

		for (const [pk, cssKey] of varNames) {
			//@ts-ignore
			const pkValue = props[pk];
			varStyles['--' + cssKey] = pkValue;
		}

		return (
			<svg
				aria-label={attrAlt}
				className={clc(className)}
				style={{
					...fillStyles(fill),
					...filterStyle(options),
					...varStyles,
					...style,
				}}
				{...(props as SVGProps)}
			>
				<use href={src} xlinkHref={src} />
			</svg>
		);
	}

	if (isImage) {
		const imagePath = '/images/';
		const attrPath = path as (typeof imageKeys)[number];

		const fullPath = imagePath + attrPath;
		const srcset = scales.map((scale) => fullPath + scale + '.png ' + scale.slice(1)).join(', ');

		return (
			<img
				alt={attrAlt}
				className={clc(className)}
				src={fullPath + scales[0] + '.png'}
				srcSet={srcset}
				style={{
					...fillStyles(fill),
					...filterStyle(options),
					...style,
				}}
				{...(props as ImageProps)}
			/>
		);
	}

	if (isObject) {
		// Object 저장 방식에 맞춰서 처리
		const assetPath = objectPath;
		const attrPath = path as (typeof objectKeys)[number];
		const src = assetPath + attrPath + '.svg';

		return (
			<object
				aria-label={attrAlt}
				className={clc(className)}
				data={src}
				role="img"
				style={{
					...fillStyles(fill),
					...filterStyle(options),
					pointerEvents: 'none',
					...style,
				}}
				type={'image/svg+xml'}
				{...(props as ObjectProps)}
			/>
		);
	}

	return <div>{path}가 존재하지 않습니다</div>;
};

export default Icon;
